// Dynamically import the JSON file for the specified language
export async function loadLocale(lng) {
    const languageResourceModule = await import(`../../i18n/${lng}.json`);
    return languageResourceModule.default;
}
//# sourceMappingURL=i18n.js.map